// AUTO-GENERATED by scripts/build-registry.js: study entry for navigation/return-track-and-heading.
import { mount } from '#engine/lesson-page.js';
import g0 from '../lessons/navigation/return-track-and-heading/return-track-and-heading.js';

mount([g0]);
